import { defineMessage } from 'react-intl';

export const previewMessageDescriptor = defineMessage({
  description: 'Default call to action text to see more information for a tooltip',
  defaultMessage: 'Select to see full message.',
  id: 'ehrVqe',
});
